'use client';

import { createPortal } from 'react-dom';
import { useAuthModal } from '@/lib/context/AuthModalContext';
import { UserAuthForm } from '@/app/register/components/UserAuthForm';
import { Modal } from '@/components/modal';

export const AuthModal = () => {
  const { isOpen, closeModal, userType } = useAuthModal();

  if (!isOpen || typeof window === 'undefined') return null;

  return createPortal(
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      className="fixed w-[95%] max-w-[488px] py-4 bg-gray-900 z-[2] rounded-2xl"
    >
      {(handleClose: () => void) => <UserAuthForm handleClose={handleClose} />}
    </Modal>,
    document.body
  );
};